import dayjs from "dayjs"

export const getDateLabel = (params) => {
  const map = {
    current_month: dayjs().format("MMMM YYYY"),
    last_month: dayjs().subtract(1, "month").format("MMMM YYYY"),
    last_30_days: `${dayjs().subtract(30, "day").format("MMM DD, YYYY")} — ${dayjs().format("MMM DD, YYYY")}`,
    total_by_scope: `${dayjs(params.date_gteq).format("MMM DD, YYYY")} — ${dayjs(params.date_lteq).format("MMM DD, YYYY")}`
  }
  return map[params.overview_range] || ""
}
